import { __assign, __awaiter, __generator } from "tslib";
import UAParser from '@amplitude/ua-parser-js';
export var userAgentEnrichmentPlugin = function (options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _a = options.osName, osName = _a === void 0 ? true : _a, _b = options.osVersion, osVersion = _b === void 0 ? true : _b, _c = options.deviceManufacturer, deviceManufacturer = _c === void 0 ? true : _c, _d = options.deviceModel, deviceModel = _d === void 0 ? true : _d;
    var uaResult;
    var plugin = {
        name: '@amplitude/plugin-user-agent-enrichment-browser',
        type: 'enrichment',
        setup: function (config) {
            return __awaiter(this, void 0, void 0, function () {
                var userAgent;
                return __generator(this, function (_a) {
                    /* istanbul ignore else */
                    if (typeof navigator !== 'undefined') {
                        userAgent = navigator.userAgent;
                    }
                    uaResult = new UAParser(userAgent).getResult();
                    config.loggerProvider.log('Installing @amplitude/plugin-user-agent-enrichment-browser.');
                    return [2 /*return*/];
                });
            });
        },
        execute: function (event) { return __awaiter(_this, void 0, void 0, function () {
            var uaOsName, UaOsVersion, UaDeviceModel, UaDeviceVendor;
            return __generator(this, function (_a) {
                uaOsName = uaResult.browser.name;
                UaOsVersion = uaResult.browser.version;
                UaDeviceModel = uaResult.device.model || uaResult.os.name;
                UaDeviceVendor = uaResult.device.vendor;
                return [2 /*return*/, __assign(__assign(__assign(__assign(__assign({}, event), (osName && { os_name: uaOsName })), (osVersion && { os_version: UaOsVersion })), (deviceManufacturer && { device_manufacturer: UaDeviceVendor })), (deviceModel && { device_model: UaDeviceModel }))];
            });
        }); },
    };
    return plugin;
};
//# sourceMappingURL=user-agent-enrichment-plugin.js.map